import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/misc/instant-ro-banner.png")